import { createReducer } from '@reduxjs/toolkit';

import { getCustomers, setFilter, setOptions } from '../actions/customer';
import { CustomerData } from '../../types/customer';
import { DEFAULT_PAGINATION_DATA } from '../../utils';
import { PageOptions } from '../../types/customer';

const INITIAL_STATE = {
  loading: false,
  list: [] as CustomerData[],
  options: {
    filters: {
      filter: '',
    },
    orderBy: 'name',
  } as PageOptions,
  pagination: DEFAULT_PAGINATION_DATA,
};

export const reducer = createReducer(INITIAL_STATE, builder => {
  builder
    .addCase(getCustomers.pending, state => {
      state.loading = true;
    })
    .addCase(getCustomers.rejected, state => {
      state.loading = false;
    })
    .addCase(getCustomers.fulfilled, (state, { payload }) => {
      if (payload) {
        if (payload.meta.pagination.page === 1) {
          state.list = payload.data;
        } else {
          state.list = [...state.list, ...payload.data];
        }
        state.pagination = payload.meta.pagination;
      }
      state.loading = false;
    })
    .addCase(setOptions, (state, { payload }) => {
      state.options = payload;
    })
    .addCase(setFilter, (state, { payload }) => {
      state.options.filters.filter = payload;
    });
});
